import type { RouteObject } from 'react-router';

import { embedSearchWidgetJobsRouteObjects } from '#/modules/embedSearchWidget/jobs/routing/embedSearchWidgetJobs.route-objects';
import * as embedSearchWidgetLayoutHorizonRouteExports from '#/modules/embedSearchWidget/layout/EmbedSearchWidgetLayout.horizon-route';
import { embedSearchWidgetVolopsRouteObjects } from '#/modules/embedSearchWidget/volops/routing/embedSearchWidgetVolops.route-objects';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { embedSearchWidgetRouteGroup } from './embedSearchWidget.routes';

export const embedSearchWidgetRouteObjects = [
  {
    path: embedSearchWidgetRouteGroup.path,
    ...horizonRouteToObject(embedSearchWidgetLayoutHorizonRouteExports),
    children: [
      ...embedSearchWidgetVolopsRouteObjects,
      ...embedSearchWidgetJobsRouteObjects,
    ],
  },
] satisfies RouteObject[];
